module.exports = __webpack_public_path__ + "img/vertical_3_2_9005.dc1f8560.png";